import React, { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { menuList } from '@/module/home/constant'
import { useOpened, useSelected } from '@/module/home/hook'
import { useAuth } from '@/module/auth/hook'
import { logout } from '@/api/domain'

function Header() {
  const { user } = useAuth()
  const {
    openProductDropwdown,
    openProfileDropdown,
    setOpenProductDropdown,
    setOpenProfileDropwdown,
  } = useOpened()
  const { productType, domain: selectedDomain, validEmailType } = useSelected()
  const [displayDropdown, setDisplayDropdown] = useState({ product: '', profile: '' })

  const activeTitle = useMemo(() => {
    const currentProduct = menuList.find((menu) => menu.id === productType)?.name
    const isDomainSelected = selectedDomain.Username !== ''

    return (
      <div className='px-0 lg:px-4'>
        <Link to={`/${productType}`}>{currentProduct}</Link>
        {isDomainSelected && (
          <>
            <span className='px-1'>/</span>
            <Link to={`/${productType}/${selectedDomain.Username}`}>{selectedDomain.Username}</Link>
          </>
        )}
        {isDomainSelected && validEmailType && (
          <>
            <span className='px-1'>/</span>
            <a>허용 이메일 설정</a>
          </>
        )}
      </div>
    )
  }, [productType, selectedDomain, validEmailType])

  const handleBarClick = () => {
    setOpenProductDropdown(!openProductDropwdown)
    setDisplayDropdown(
      !openProductDropwdown
        ? { ...displayDropdown, product: '' }
        : { ...displayDropdown, product: 'none' },
    )
  }

  const handleProfileClick = () => {
    setOpenProfileDropwdown(!openProfileDropdown)
    setDisplayDropdown(
      !openProfileDropdown
        ? { ...displayDropdown, profile: '' }
        : { ...displayDropdown, profile: 'none' },
    )
  }

  const handleLogout = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    try {
      void logout()
      window.location.href ='/?loggedIn=false'
    } catch (error) {
      console.error('로그아웃 실패:', error);
    }
  };

  return (
    <div className='flex items-center px-2 bg-slate-200/20 sticky top-0 z-50 backdrop-filter backdrop-blur-[2px]'>
      <div className='flex-none lg:hidden'>
        <div className='dropdown' onClick={handleBarClick}>
          <label tabIndex={0} className='ml-1 btn btn-ghost btn-circle btn-sm'>
            <i className='text-gray-400 fa fa-thin fa-bars'></i>
          </label>
          <ul
            tabIndex={0}
            style={{ display: displayDropdown.product }}
            className='p-2 mt-3 shadow menu menu-compact dropdown-content bg-slate-200 rounded-box w-52'
          >
            <li className='menu-title'>
              <span>상품 목록</span>
            </li>
            {menuList.map((menu) => (
              <li key={menu.id}>
                <Link to={`/${menu.id}`} className={`${menu.id === productType ? 'active' : ''}`}>
                  {menu.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className='flex-1 text-xs text-gray-500 truncate'>{activeTitle}</div>
      <div className='flex-none'>
        <div className='flex items-center'>
          <div className='dropdown dropdown-left' onClick={handleProfileClick}>
            <label tabIndex={0} className='btn btn-ghost btn-circle avatar'>
              <div className='w-8 rounded-full'>
                <img src={user.picture} alt={`${user.name}'s profile`} />
              </div>
            </label>
            <ul
              tabIndex={0}
              style={{ display: displayDropdown.profile }}
              className='p-2 mt-3 shadow menu menu-compact dropdown-content bg-slate-200 rounded-box w-52'
            >
              <li>
                <a href="#" onClick={handleLogout}>
                  Logout
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Header
